import React from 'react';
import { Checkbox, Form } from 'antd';

const Active = ({ disabled }) => {
    return (
        <div>
            <Form.Item
                name="active"
                valuePropName="checked"
                style={{ margin: 0 }}
            >
                <Checkbox disabled={disabled}>
                    Rezerwacja online włączona
                </Checkbox>
            </Form.Item>
            <small>
                Przed włączeniem rezerwacji online upewnij się, że sprzęt i ceny
                do tej trasy są skonfigurowane.
            </small>
        </div>
    );
};

export default Active;
